/** @format */
import React, { FunctionComponent, ReactElement } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import adescomStyle from '../../../../../assets/jss/adescom/adescomStyle';
import { SimCardServiceItem } from '../../../../../interfaces/collections/SimCardServiceInterface';
import I18n from '../../../../../components/Translate/I18n';
import GridItem from '../../../../../components/Grid/GridItem';
import GridContainer from '../../../../../components/Grid/GridContainer';

const useStyle = makeStyles(adescomStyle);

type SdgParamsType = {
    simCardService: SimCardServiceItem;
};

interface ServiceComponentParam {
    name: string;
    value: string | number | boolean | null;
}

export const SdgParams: FunctionComponent<SdgParamsType> = ({ simCardService }): ReactElement | null => {
    const classes = useStyle();

    const tableCellRoot = { root: classes.tableCellRoot };

    let isComponentParams = false;
    let jsonObjectParams: Array<ServiceComponentParam> = [];

    if (simCardService.servicesParams && simCardService.servicesParams.length > 0) {
        for (let i = 0; i < simCardService.servicesParams.length; i++) {
            if (simCardService.servicesParams[i].mainname === 'componentParams') {
                isComponentParams = true;
                jsonObjectParams = JSON.parse(simCardService.servicesParams[i].value);
            }
        }
    }

    const getParameterValue = (param: string | number | boolean | null): string | number => {
        if (typeof param === 'boolean') {
            if (param) {
                return 'true';
            }
            return 'false';
        }
        return param ?? '';
    };

    const f = 3;

    return (
        <TableRow>
            <TableCell classes={tableCellRoot} padding="none" align="right" />
            <TableCell classes={tableCellRoot} padding="none" align="left" colSpan={3}>
                <React.Fragment>
                    {isComponentParams && (
                        <GridContainer>
                            {jsonObjectParams &&
                                jsonObjectParams.map((row) => (
                                    <React.Fragment key={'componentParams' + row.name + simCardService.id}>
                                        <GridItem xs={f}>
                                            <I18n trans="simcard:f.param_name" />
                                        </GridItem>
                                        <GridItem xs={f}>{row.name}</GridItem>
                                        <GridItem xs={f}>
                                            <I18n trans="simcard:f.param_value" />
                                        </GridItem>
                                        <GridItem xs={f}>{getParameterValue(row.value)}</GridItem>
                                    </React.Fragment>
                                ))}
                        </GridContainer>
                    )}
                </React.Fragment>
            </TableCell>
        </TableRow>
    );
};
